<!--
/**
  * 统计周期组件
    @author weili
  * @date 2023-06-21
  参数说明：
    formData Object 表单对象
    value String 日期字段名
    defaultProps Object 日期控件配置
    handleStatDateChange Function(value,initflag) 选择日期后触发父组件的回调事件(开始/结束时间的值数组,是否首次进入界面)
    statType Array 设置统计类型的勾选项(默认本日、本月、本年)
    showAllStatType(true|*false) 是否显示所有统计类型：本日、本周、本月、本季度、本年
     hasDefaultValue(*true|false) 是否设置默认日期，如页面使用了EXList脚本加载数据，要配合使用autoLoad: false，并且在handleStatDateChange方法根据initflag判断手动加载数据；
                                  设置为false时，如页面使用了EXList脚本获取数据，要去掉autoLoad: false
     defaultStatValue String 设置默认日期的统计类型本日、本周、本月、本季度、本年
     showCheckBox(*true|false) 是否显示统计类型勾选；false时隐藏勾选只显示日期选择控件
  */
-->
<template>
    <div>
        <!-- <el-radio-group 
            v-model="statType"
            >
            <el-radio-button v-for="childItem in listTypeInfo.statTypeList" 
                        :label="childItem.value" :key="childItem.value">{{childItem.label}}</el-radio-button>
        </el-radio-group> -->
        <el-checkbox-group  v-if="showCheckBox" class="checkbox-box" 
            v-model="curType"
            @change="(value)=>curTypeEvent(value)">
                <el-checkbox v-for="childItem in curTypeList"
                  :label="childItem" :key="childItem">{{childItem}}</el-checkbox>
        </el-checkbox-group>
        <el-date-picker
            class="date-picker" 
            v-model="formData[value]"
            :type="defaultProps.dateType"
            :picker-options="defaultProps.TimePickerOptions"
            :disabled="defaultProps.disabled"
            :clearable="defaultProps.clearable==false?false:true"
            :value-format="defaultProps.valueFormat"
            :format="defaultProps.format"
            :range-separator="defaultProps.separator"
            :start-placeholder="defaultProps.startPH"
            :end-placeholder="defaultProps.endPH"
            :default-time="defaultProps.defaultTime"
            :placeholder="defaultProps.placeholder?defaultProps.placeholder:`请选择${defaultProps.label}`"  
            @change="statDateEvent"
        />
    </div>
</template>
  
  <script>
  import { parseTime } from '@/utils'
  import * as cycle from '@/utils/cycle'
  export default {
   name: "EXStatDateSearch",
   props: {
    formData: {
        type: Object,
        default: {},
    },
    value:String,
    defaultProps: {
        type: Object,
        default:()=>({
            dateType: 'datetimerange',
            disabled: false,
            clearable: true,
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            format: 'yyyy-MM-dd HH:mm',
            label: '统计日期',
            separator: '至',
            startPH: '开始日期',
            endPH: '结束日期',
            defaultTime: ['00:00:00', '23:59:59']
        })
    },
    handleStatDateChange: Function,
    showAllStatType: {
        type: Boolean,
        default: false
    },
    statType: {
        type: Array,
        default:()=>(['本日','本月','本年'])
    },
    hasDefaultValue: {
        type: Boolean,
        default: true
    },
    defaultStatValue:{
        type: String,
        default: '本月'
    },
    showCheckBox:{
        type: Boolean,
        default: true
    }
   },
   computed: {
    curTypeList() {
         return this.showAllStatType?['本日','本周','本月','本季度','本年']:this.statType
    }
  },
   data() {
        return {
            // statDate: '',
            // statType: '01',  //默认按日统计
            curType: [],
            // curTypeList: ['本日','本月','本年']
        }
    },
    created(){
        //设置默认值
        if(this.hasDefaultValue){
            this.curType = [this.defaultStatValue]
            this.curTypeEvent([this.defaultStatValue],true)
        }
    },
   methods: {
        //日期自定义选择事件 取消前面的勾选
        statDateEvent(){
            this.resetCurType()
            this.$emit("handleStatDateChange",this.formData[this.value]) //父页面回调
        },
       curTypeEvent(value,initflag){
            if(value.length <= 0){
                this.$emit("handleStatDateChange",['',''])  //父页面回调
                return
            }
            if(value.length > 1){
                this.curType.splice(0,1)
            }
            var start = "",end = ""
            switch(value[0]){
                case '本日':
                start = parseTime(new Date(),'{y}-{m}-{d}')
                end = parseTime(new Date(),'{y}-{m}-{d}')
                        break;
                case '本周':
                start = cycle.getWeek('s',0)
                end = cycle.getWeek('e',0)
                        break;
                case '本月':
                start = cycle.getMonth('s',0)
                end = cycle.getMonth('e',0)
                        break;
                case '本季度':
                start = cycle.getQuater('s',0)
                end = cycle.getQuater('e',0)
                        break;
                case '本年':
                start = cycle.getYear('s',0)
                end = cycle.getYear('e',0)
                        break;
            }
            this.$forceUpdate();
            this.$emit("handleStatDateChange",[`${start} 00:00:00`,`${end} 23:59:59`],initflag) //父页面回调
        },
        resetCurType(){
            this.curType = []
        }
   },
  };
  </script>
  
  <style lang="scss" scoped>
  .date-picker{
    margin-left: 10px;
  }
  .checkbox-box{
    display:inline;margin-left: 20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/EXSearchHead/statDateSearch.vue